import React, { useRef } from "react";
import { Box, Button, Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import HistoryIcon from "@mui/icons-material/History";
import SendIcon from "@mui/icons-material/Send";
import NewsletterPublishAllView from "./NewsletterPublishAllView";
import NewsletterPublishGroupsView from "./NewsletterPublishGroupsView";
import NewsletterPublishSelectedView from "./NewsletterPublishSelectedView";
import NewsletterPublishCsvView from "./NewsletterPublishCsvView";
import NewsletterHistoryView from "./NewsletterHistoryView";
import ContentSectionPanel from "../../content/ContentSectionPanel";
import useEditorViewportHeight from "../../newsletter-editor/hooks/useEditorViewportHeight";
import {
  contentViewportGridFillSx,
  contentViewportPanelSx,
} from "../../content/contentEditorStyles";
import { publishHubGridSx, publishNavItemSx } from "./newsletterPublishStyles";

export const VIEW_ALL = "all";
export const VIEW_GROUPS = "groups";
export const VIEW_SELECTED = "selected";
export const VIEW_LISTA = "lista";
export const VIEW_HISTORY = "history";

const LEGACY_VIEW_CSV = "csv";

const normalizePublishView = (rawView) => {
  if (rawView === LEGACY_VIEW_CSV) {
    return VIEW_LISTA;
  }
  return rawView || VIEW_ALL;
};

const NAV_ITEMS = [
  { key: VIEW_HISTORY, label: "Storico", icon: HistoryIcon },
  { key: VIEW_ALL, label: "Tutti", icon: SendIcon },
  { key: VIEW_GROUPS, label: "Gruppi", icon: SendIcon },
  { key: VIEW_SELECTED, label: "Selezionati", icon: SendIcon },
  { key: VIEW_LISTA, label: "Lista", icon: SendIcon },
];

const VIEW_TITLES = {
  [VIEW_ALL]: "Invia a tutti gli iscritti",
  [VIEW_GROUPS]: "Invia a gruppi",
  [VIEW_SELECTED]: "Invia a iscritti selezionati",
  [VIEW_LISTA]: "Invia a lista",
};

const NewsletterPublishHub = () => {
  const panelRef = useRef(null);
  const panelHeight = useEditorViewportHeight(panelRef);
  const [searchParams, setSearchParams] = useSearchParams();
  const view = normalizePublishView(searchParams.get("view"));

  const setView = (nextView) => {
    setSearchParams((current) => {
      const next = new URLSearchParams(current);
      next.set("tab", "pubblica");
      next.set("view", nextView);
      return next;
    });
  };

  const renderPublishView = () => {
    switch (view) {
      case VIEW_GROUPS:
        return <NewsletterPublishGroupsView />;
      case VIEW_SELECTED:
        return <NewsletterPublishSelectedView />;
      case VIEW_LISTA:
        return <NewsletterPublishCsvView />;
      case VIEW_ALL:
      default:
        return <NewsletterPublishAllView />;
    }
  };

  return (
    <Box ref={panelRef} sx={contentViewportPanelSx(panelHeight)}>
      <Box sx={{ ...publishHubGridSx, ...contentViewportGridFillSx }}>
        <ContentSectionPanel title="OPZIONI" fillBody panelScroll>
          <Stack spacing={0.5}>
            {NAV_ITEMS.map((item) => {
              const Icon = item.icon;
              const active = view === item.key;
              return (
                <Button
                  key={item.key}
                  fullWidth
                  startIcon={<Icon fontSize="small" />}
                  onClick={() => setView(item.key)}
                  sx={publishNavItemSx(active)}
                >
                  {item.label}
                </Button>
              );
            })}
          </Stack>
        </ContentSectionPanel>

        {view === VIEW_HISTORY ? (
          <NewsletterHistoryView onNavigatePublish={() => setView(VIEW_ALL)} />
        ) : (
          <ContentSectionPanel title={VIEW_TITLES[view] || VIEW_TITLES[VIEW_ALL]} fillBody>
            {renderPublishView()}
          </ContentSectionPanel>
        )}
      </Box>
    </Box>
  );
};

export default NewsletterPublishHub;
